import script from "./form9.vue?vue&type=script&setup=true&lang=js"
export * from "./form9.vue?vue&type=script&setup=true&lang=js"

import "./form9.vue?vue&type=style&index=0&id=a9b5a5ee&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9b5a5ee"]])

export default __exports__